import {
	Judge_ConcludedCases,
	Judge_Dashboard,
	Judge_MyFiles,
	Judge_Notification,
	Judge_Profile,
} from '../features/judge';

import Judges from '../features/judge/judges';

import Open from '../features/judge/open-judges';
import ProcessPayment from '../features/judge/proceed-payment';
import Recalled from '../features/judge/recall';

export const judge_Routes = [
	{
		id: '1',
		title: 'Dashboard',
		component: Judge_Dashboard,
		path: 'judge',
	},
	{
		id: '2',
		title: 'Case Folders',
		component: Judge_MyFiles,
		path: 'judge/case-folders',
	},
	{
		id: '3',
		title: 'Notification',
		component: Judge_Notification,
		path: 'judge/notification',
	},
	{
		id: '4',
		title: 'Profile',
		component: Judge_Profile,
		path: 'judge/profile',
	},

	{
		id: '6',
		title: 'Concluded Cases',
		component: Judge_ConcludedCases,
		path: 'judge/concluded-cases',
	},
	{
		id: '7',
		title: 'process',
		component: ProcessPayment,
		path: 'judge/process',
	},
	{
		id: '8',
		title: 'recalled',
		component: Recalled,
		path: 'judge/recall',
	},
	{
		id: '9',
		title: 'Cause list',
		component: Judges,
		path: 'judge/cause-list',
	},
	{
		id: '10',
		title: 'Open',
		component: Open,
		path: 'judge/judges/open',
	},
];
